import { noop } from "@common/helpers/function";
import { CreateRampConnection } from "@components/ramp/CreateRampConnection";

// eslint-disable-next-line react-refresh/only-export-components
export const BILL_CONNECT_CTA_TITLE = "Connect Ramp to see your bills";
// eslint-disable-next-line react-refresh/only-export-components
export const BILL_CONNECT_CTA_SUBTITLE =
    "Create, manage, and track all your bills in one place.";

export const BillConnectButtons: React.FC = () => (
    <CreateRampConnection
        onCreated={noop}
        btnVariant="primary"
        btnSize="md"
        toastMessage="Syncing Ramp Bills... Check back in a few minutes."
    >
        Connect Ramp
    </CreateRampConnection>
);
